import * as yup from 'yup';

export const getIsEmailValid = (value: string) => yup.string().defined().email().isValidSync(value);
